import { render, staticRenderFns } from "./Bando33Fase6.vue?vue&type=template&id=8bcd52b0&scoped=true"
import script from "./Bando33Fase6.vue?vue&type=script&lang=js"
export * from "./Bando33Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd52b0",
  null
  
)

export default component.exports